import { AlertCircle, RefreshCw } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';

import { useClientCommunications } from './ClientCommunicationsContext';
import { AllCommunicationsView } from './views/AllCommunicationsView';
import { AttachmentsView } from './views/AttachmentsView';
import { CallsView } from './views/CallsView';
import { EmailsView } from './views/EmailsView';
import { TextsView } from './views/TextsView';

export const CommunicationsContent: React.FC = () => {
  const { activeTab, error, refreshCommunications } = useClientCommunications();

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
        <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mb-3">
          <AlertCircle className="h-5 w-5 text-red-600" />
        </div>
        <p className="text-sm font-semibold text-zinc-800 mb-1">
          Unable to load communications
        </p>
        <p className="text-xs text-zinc-500 font-medium mb-4 max-w-xs">
          {error.message || 'Something went wrong. Please try again.'}
        </p>
        <Button
          onClick={() => refreshCommunications()}
          variant="outline"
          size="sm"
          className="h-8 font-semibold"
        >
          <RefreshCw className="h-3.5 w-3.5 mr-1.5" />
          Retry
        </Button>
      </div>
    );
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'all':
        return <AllCommunicationsView />;
      case 'texts':
        return <TextsView />;
      case 'calls':
        return <CallsView />;
      case 'emails':
        return <EmailsView />;
      case 'attachments':
        return <AttachmentsView />;
      default:
        return <AllCommunicationsView />;
    }
  };

  return <div className="h-full bg-white">{renderContent()}</div>;
};

export default CommunicationsContent;
